// extracted by mini-css-extract-plugin
export default {"description":"template-tag_description__MsScy","labelContainer":"template-tag_labelContainer__sxUd1","labelButton":"template-tag_labelButton__q9zqM"};